import { axios } from '../../lib/axios';

const CLEARSTEP_API_PREFIX = (
  process.env.REACT_APP_CLEARSTEP_PROXY_BASE || 'clearstep/v1'
).replace(/^\/|\/$/g, '');

function unwrapClearstepResponse(response) {
  if (response && Object.prototype.hasOwnProperty.call(response, 'data')) {
    return response.data;
  }
  return response;
}

function buildErrorMessage(error) {
  const status = error?.response?.status;
  const apiMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.detail;

  if (status === 401) {
    return apiMessage || 'You are not authorized to use the symptom checker. Please sign in again.';
  }

  if (status === 404) {
    return apiMessage || 'Clearstep endpoint was not found. Check the backend proxy route.';
  }

  if (status) {
    return apiMessage || `Clearstep request failed with status code ${status}.`;
  }

  return error?.message || 'Clearstep request failed.';
}

async function request(path, options = {}) {
  const method = (options.method || 'GET').toLowerCase();
  const url = `${CLEARSTEP_API_PREFIX}${path}`;

  try {
    if (method === 'post') {
      const response = await axios.post(url, options.body || {});
      return unwrapClearstepResponse(response);
    }

    const response = await axios.get(url);
    return unwrapClearstepResponse(response);
  } catch (error) {
    throw new Error(buildErrorMessage(error));
  }
}

export function findComplaints(text) {
  return request(`/nlp?text=${encodeURIComponent(text)}`, { method: 'GET' });
}

export function startClearstepConversation({ complaintId, sex, age }) {
  return request('/start_conversation', {
    method: 'POST',
    body: {
      complaint_id: complaintId,
      Sex: sex,
      ...(age || {}),
    },
  });
}

export function answerClearstepQuestion({ questionId, optionIds, conversationId }) {
  return request('/answer_question', {
    method: 'POST',
    body: {
      question_id: questionId,
      affirmed_option_ids: optionIds,
      conversation_id: conversationId,
    },
  });
}
